<script setup>
import { ref, onMounted, computed, onUnmounted } from "vue";
import { useQuizEmojiStore } from "@/stores/storeQuizEmoji";


const storeQuizEmoji = useQuizEmojiStore();

const pointerEventsNone = ref(false);
const currentAnswerId = ref(null);
const emojiLength = computed(() => storeQuizEmoji.answers.length);

const gridStyle = computed(() => ({	
	gridTemplateColumns: `repeat(${emojiLength.value}, 1fr)`
}));

const showadditionalData = async (id) => {
	currentAnswerId.value = id;
	await storeQuizEmoji.answerToQuestion(id)
	pointerEventsNone.value = true;
};


onMounted(() => {});
onUnmounted(() => {
    storeQuizEmoji.resetTimer();
});
</script>

<template>
	<div class="quiz-game">
		<div class="container">
			<div class="quiz-game__container">
				<h2 class="quiz-game__title">Угадай картину</h2>
				<div class="quiz-game__controls">
					<div class="found-words">
						<span class="found-words__title">Вопросов:</span>
						<div class="found-words__counter">
							<span>{{ storeQuizEmoji.currentQuestion || 0 }}</span>
							<span>/</span>
							<span>{{ storeQuizEmoji.totalQuestion || 10 }}</span>
						</div>
					</div>
					<div class="timer">
						<svg width="32" height="32"><use href="#timer"></use></svg>
						<span>{{ storeQuizEmoji.remainingTime.minutes }}:{{ storeQuizEmoji.remainingTime.secundes }}</span>
					</div>
				</div>

				<div class="questions">
					<div class="quiz-game__loader" v-if="storeQuizEmoji.isLoaderQuiz">
						<img class="quiz-game__loader-img" width="103" height="103" src="@/assets/img/icons/loader.svg" alt="изображение" />
					</div>
					<div class="questions__header">
						<div class="emoji" v-for="emoji in storeQuizEmoji.emojis" :key="emoji.text">{{ emoji.text }}</div>		
					</div>

					<div class="questions__list">

						<div 
							:class="['question', {active : storeQuizEmoji.additionalData && answer.right_answer, 'pointer-events-none': pointerEventsNone}]"
							v-for="answer in storeQuizEmoji.answers" 
							:key="answer.id"
							@click="showadditionalData(answer.id)"
						>
							<div class="question__header">
								<h5 class="question__title">{{ answer.text }}</h5>
								<svg v-if="storeQuizEmoji.additionalData && answer.right_answer" width="24" height="24"><use href="#answer_right"></use></svg>
								<svg v-if="storeQuizEmoji.additionalData && currentAnswerId === answer.id && !answer.right_answer" width="24" height="24"><use href="#answer_error"></use></svg>
							</div>
							
							<transition name="body">
								<div class="question__body" v-if="storeQuizEmoji.additionalData && answer.right_answer">
									<div class="question__image">
										<img class="full-img" width="268" height="300" :src="storeQuizEmoji.additionalDataImage" alt="изображение" />
									</div>
									<div class="question__body-title">Интересный факт:</div>
									<p class="question__desc">{{ storeQuizEmoji.additionalData.text }}</p>
								</div>
							</transition>
						</div>

					</div>
					<button class="question__btn btn --blue" @click="storeQuizEmoji.question(), pointerEventsNone = false">Далее</button>
				</div>
			</div>
		</div>
	</div>
</template>
<style lang="scss" scoped>
@use "@/assets/scss/base/vars";
.quiz-game {
	position: relative;
	padding: 3.4rem 0 10.5rem;
	color: #fff;
	background-image: url("@/assets/img/games/game_line_1.webp"), url("@/assets/img/games/game_line_2.webp");
	background-repeat: no-repeat;
	background-position: 0% 0%, 100% 100%; /* x y*/
	background-size: 16%, 18%;
	@media (max-width: vars.$xx) {
		background-image: none;
		padding: 4.5rem 0 7rem;
	}
}

.questions {
	position: relative;
	max-width: 74rem;
	width: 100%;
}

.questions__header {
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 3rem;
	padding: 3rem 13rem;
	border-radius: var(--border-radius);
	background: var(--system-fill-light);
	margin-bottom: 2.4rem;
	@media (max-width: vars.$x480) {
		padding: 3rem;

	}
	
}
.emoji {
	font-weight: 500;
	font-size: 7.5rem;
	line-height: 160%;
	@media (max-width: vars.$x480) {
		font-size: 3.6rem;
	}
}
.questions__list {
	display: grid;
	gap: 1.6rem;
	margin-bottom: 2.4rem;
}
.question {
	border-radius: var(--border-radius);
	padding: 3rem 2.2rem 3rem 4rem;
	background: var(--system-fill-light);
	color: var(--text-accent-1-100);
	cursor: pointer;
	@media (max-width: vars.$x480) {
		padding: 2rem;
	}
	&.active {
		background: var(--fill-accent-1-1);
		color: #fff;
		.question__body {
		// 	display: flex;
		// 	opacity: 1;
		// 	@starting-style {
		// 		opacity: 0;
		// 	}
		}
	}
	&.pointer-events-none {
		pointer-events: none;
	}
}
.question__header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 1rem;

	svg {
		stroke: transparent;
		width: 2.4rem;
		height: 2.4rem;
		flex-shrink: 0;
	}
}
.question__title {
	font-weight: 400;
	font-size: 2.4rem;
	line-height: 140%;
	@media (max-width: vars.$x480) {
		font-size: 1.6rem;
	}
}
.question__body {
	display: flex;

	padding-top: 2.4rem;
	flex-direction: column;
	gap: 5px;
}
.question__image {
	width: 26.8rem;
	@media (max-width: vars.$x480) {
		width: 100%;
	}
}
.question__body-title {
	font-weight: 700;
	font-size: 1.6rem;
	line-height: 140%;
}
.question__desc {
	font-weight: 400;
	font-size: 1.6rem;
	line-height: 140%;
}
.question__btn {
	width: 100%;
}


.quiz-game__overlay {
	top: 0;
	right: 0;
	height: 100%;
	width: 100%;
	z-index: 4;
	transition: 0.5s;
	position: fixed;
	background-color: rgba(41, 41, 41, 0.51);
}
.quiz-game__loader {
	position: fixed;
	inset: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: rgba(255, 255, 255, 0.1);
	backdrop-filter: blur(10.800000190734863px);
	z-index: 2;
}
.quiz-game__loader-img {
	animation: animationLoader 0.7s linear infinite;
}
.quiz-game__container {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 2.3rem;
	@media (max-width: vars.$x480) {
		gap: 2.8rem;
	}
}
.quiz-game__controls {
	max-width: 64.6rem;
	display: grid;
	grid-template-columns: repeat(2, 18rem);
	align-items: center;
	justify-items: center;
	gap: 5.3rem;
	@media (max-width: vars.$xx) {
		grid-template-columns: 1fr 6.2rem;
		gap: 5rem;
	}
	@media (max-width: vars.$x360) {
		gap: 3rem;
	}
}
.quiz-game__title {
	font-weight: 500;
	font-size: 3.2rem;
	line-height: 120%;
	text-align: center;
	@media (max-width: vars.$x480) {
		font-size: 2.4rem;
	}
}
.found-words {
	display: grid;
	justify-items: center;
	gap: 3px;
	color: #fff;
}
.found-words__title {
	font-weight: 400;
	font-size: 2.4rem;
	line-height: 140%;
	@media (max-width: vars.$x480) {
		font-size: 2rem;
	}
}
.found-words__counter {
	font-weight: 400;
	font-size: 4rem;
	line-height: 140%;
	text-align: center;
	@media (max-width: vars.$x480) {
		font-size: 2.8rem;
	}
	span {
	}
}

.timer {
	width: 100%;
	display: flex;
	align-items: center;
	flex-direction: column;
	svg {
		width: 3.2rem;
		height: 3.2rem;
	}
	span {
		font-weight: 400;
		font-size: 4rem;
		line-height: 140%;
		text-align: center;
		@media (max-width: vars.$x480) {
			font-size: 2.8rem;
		}
	}
}

.v-enter-active,
.v-leave-active {
    transition: all 0.25s ease-out;
}

.v-enter-from{
    opacity: 0;
  transform: translate(-50%, 10px);
}
.v-leave-to {
  opacity: 0;
  transform: translate(-50%, 10px);
}

.body-enter-active,
.body-leave-active {
	transition: 0.5s ease;
}

.body-enter-from,
.body-leave-to {
	opacity: 0;
}
</style>
